/**
 * This file was auto-generated by client-types. Do not manually edit this file.
 * Your changes would be automatically overwritten.
 *
 * Service Documentation: https://private.hubteam.com/shoebill/service/com.hubspot.video.rpc.HubSpotVideoRpc
 */
import * as References from './HubSpotVideoRpc';
import { createRpcClientV2 } from 'rpc-client-utils';
import http from 'hub-http/clients/apiClient';
import { registerQuery, registerMutation } from 'data-fetching-client/next';
export const chirpClient = createRpcClientV2({
  hubHttpClient: http
});

/**
 * Docs: https://private.hubteam.com/shoebill/service/com.hubspot.video.rpc.HubSpotVideoRpc#getVideoByVideoId
 */
export const GET_VIDEO_BY_VIDEO_ID_QUERY_FIELD_NAME = 'com_hubspot_video_rpc_HubSpotVideoRpc_getVideoByVideoId';
export const GET_VIDEO_BY_VIDEO_ID_QUERY = /* #__PURE__ */registerQuery({
  fieldName: GET_VIDEO_BY_VIDEO_ID_QUERY_FIELD_NAME,
  args: ['videoId'],
  fetcher(request, ctx) {
    var _ctx$customClient;
    return ((_ctx$customClient = ctx.customClient) !== null && _ctx$customClient !== void 0 ? _ctx$customClient : chirpClient).call(References.getVideoByVideoIdRpc, {
      timeout: ctx.timeout,
      request
    });
  }
});

/**
 * Docs: https://private.hubteam.com/shoebill/service/com.hubspot.video.rpc.HubSpotVideoRpc#getCrmVideoByVideoId
 */
export const GET_CRM_VIDEO_BY_VIDEO_ID_QUERY_FIELD_NAME = 'com_hubspot_video_rpc_HubSpotVideoRpc_getCrmVideoByVideoId';
export const GET_CRM_VIDEO_BY_VIDEO_ID_QUERY = /* #__PURE__ */registerQuery({
  fieldName: GET_CRM_VIDEO_BY_VIDEO_ID_QUERY_FIELD_NAME,
  args: ['videoId'],
  fetcher(request, ctx) {
    var _ctx$customClient2;
    return ((_ctx$customClient2 = ctx.customClient) !== null && _ctx$customClient2 !== void 0 ? _ctx$customClient2 : chirpClient).call(References.getCrmVideoByVideoIdRpc, {
      timeout: ctx.timeout,
      request
    });
  }
});

/**
 * Docs: https://private.hubteam.com/shoebill/service/com.hubspot.video.rpc.HubSpotVideoRpc#getVideosByVideoIds
 */
export const GET_VIDEOS_BY_VIDEO_IDS_QUERY_FIELD_NAME = 'com_hubspot_video_rpc_HubSpotVideoRpc_getVideosByVideoIds';
export const GET_VIDEOS_BY_VIDEO_IDS_QUERY = /* #__PURE__ */registerQuery({
  fieldName: GET_VIDEOS_BY_VIDEO_IDS_QUERY_FIELD_NAME,
  args: ['videoIds'],
  fetcher(request, ctx) {
    var _ctx$customClient3;
    return ((_ctx$customClient3 = ctx.customClient) !== null && _ctx$customClient3 !== void 0 ? _ctx$customClient3 : chirpClient).call(References.getVideosByVideoIdsRpc, {
      timeout: ctx.timeout,
      request
    });
  }
});

/**
 * Docs: https://private.hubteam.com/shoebill/service/com.hubspot.video.rpc.HubSpotVideoRpc#getVideoByFileId
 */
export const GET_VIDEO_BY_FILE_ID_QUERY_FIELD_NAME = 'com_hubspot_video_rpc_HubSpotVideoRpc_getVideoByFileId';
export const GET_VIDEO_BY_FILE_ID_QUERY = /* #__PURE__ */registerQuery({
  fieldName: GET_VIDEO_BY_FILE_ID_QUERY_FIELD_NAME,
  args: ['sourceFileId'],
  fetcher(request, ctx) {
    var _ctx$customClient4;
    return ((_ctx$customClient4 = ctx.customClient) !== null && _ctx$customClient4 !== void 0 ? _ctx$customClient4 : chirpClient).call(References.getVideoByFileIdRpc, {
      timeout: ctx.timeout,
      request
    });
  }
});

/**
 * Docs: https://private.hubteam.com/shoebill/service/com.hubspot.video.rpc.HubSpotVideoRpc#getVideosByFileIdsBulk
 */
export const GET_VIDEOS_BY_FILE_IDS_BULK_QUERY_FIELD_NAME = 'com_hubspot_video_rpc_HubSpotVideoRpc_getVideosByFileIdsBulk';
export const GET_VIDEOS_BY_FILE_IDS_BULK_QUERY = /* #__PURE__ */registerQuery({
  fieldName: GET_VIDEOS_BY_FILE_IDS_BULK_QUERY_FIELD_NAME,
  args: ['sourceFileIds'],
  fetcher(request, ctx) {
    var _ctx$customClient5;
    return ((_ctx$customClient5 = ctx.customClient) !== null && _ctx$customClient5 !== void 0 ? _ctx$customClient5 : chirpClient).call(References.getVideosByFileIdsBulkRpc, {
      timeout: ctx.timeout,
      request
    });
  }
});

/**
 * Docs: https://private.hubteam.com/shoebill/service/com.hubspot.video.rpc.HubSpotVideoRpc#getVideosByFileIdsPaged
 */
export const GET_VIDEOS_BY_FILE_IDS_PAGED_QUERY_FIELD_NAME = 'com_hubspot_video_rpc_HubSpotVideoRpc_getVideosByFileIdsPaged';
export const GET_VIDEOS_BY_FILE_IDS_PAGED_QUERY = /* #__PURE__ */registerQuery({
  fieldName: GET_VIDEOS_BY_FILE_IDS_PAGED_QUERY_FIELD_NAME,
  args: ['sourceFileIds', 'pageLength', 'offset'],
  fetcher(request, ctx) {
    var _ctx$customClient6;
    return ((_ctx$customClient6 = ctx.customClient) !== null && _ctx$customClient6 !== void 0 ? _ctx$customClient6 : chirpClient).call(References.getVideosByFileIdsPagedRpc, {
      timeout: ctx.timeout,
      request
    });
  }
});

/**
 * Docs: https://private.hubteam.com/shoebill/service/com.hubspot.video.rpc.HubSpotVideoRpc#getVideoByCrmId
 */
export const GET_VIDEO_BY_CRM_ID_QUERY_FIELD_NAME = 'com_hubspot_video_rpc_HubSpotVideoRpc_getVideoByCrmId';
export const GET_VIDEO_BY_CRM_ID_QUERY = /* #__PURE__ */registerQuery({
  fieldName: GET_VIDEO_BY_CRM_ID_QUERY_FIELD_NAME,
  args: ['crmObjectId'],
  fetcher(request, ctx) {
    var _ctx$customClient7;
    return ((_ctx$customClient7 = ctx.customClient) !== null && _ctx$customClient7 !== void 0 ? _ctx$customClient7 : chirpClient).call(References.getVideoByCrmIdRpc, {
      timeout: ctx.timeout,
      request
    });
  }
});

/**
 * Docs: https://private.hubteam.com/shoebill/service/com.hubspot.video.rpc.HubSpotVideoRpc#softDeleteVideoByFileId
 */
export const SOFT_DELETE_VIDEO_BY_FILE_ID_MUTATION_FIELD_NAME = 'com_hubspot_video_rpc_HubSpotVideoRpc_softDeleteVideoByFileId';
export const SOFT_DELETE_VIDEO_BY_FILE_ID_MUTATION = /* #__PURE__ */registerMutation({
  fieldName: SOFT_DELETE_VIDEO_BY_FILE_ID_MUTATION_FIELD_NAME,
  args: ['sourceFileId'],
  fetcher(request, ctx) {
    var _ctx$customClient8;
    return ((_ctx$customClient8 = ctx.customClient) !== null && _ctx$customClient8 !== void 0 ? _ctx$customClient8 : chirpClient).call(References.softDeleteVideoByFileIdRpc, {
      timeout: ctx.timeout,
      request
    });
  }
});

/**
 * Docs: https://private.hubteam.com/shoebill/service/com.hubspot.video.rpc.HubSpotVideoRpc#softDeleteVideosByFileIdsBulk
 */
export const SOFT_DELETE_VIDEOS_BY_FILE_IDS_BULK_MUTATION_FIELD_NAME = 'com_hubspot_video_rpc_HubSpotVideoRpc_softDeleteVideosByFileIdsBulk';
export const SOFT_DELETE_VIDEOS_BY_FILE_IDS_BULK_MUTATION = /* #__PURE__ */registerMutation({
  fieldName: SOFT_DELETE_VIDEOS_BY_FILE_IDS_BULK_MUTATION_FIELD_NAME,
  args: ['sourceFileIds'],
  fetcher(request, ctx) {
    var _ctx$customClient9;
    return ((_ctx$customClient9 = ctx.customClient) !== null && _ctx$customClient9 !== void 0 ? _ctx$customClient9 : chirpClient).call(References.softDeleteVideosByFileIdsBulkRpc, {
      timeout: ctx.timeout,
      request
    });
  }
});

/**
 * Docs: https://private.hubteam.com/shoebill/service/com.hubspot.video.rpc.HubSpotVideoRpc#hardDeleteVideoByFileId
 */
export const HARD_DELETE_VIDEO_BY_FILE_ID_MUTATION_FIELD_NAME = 'com_hubspot_video_rpc_HubSpotVideoRpc_hardDeleteVideoByFileId';
export const HARD_DELETE_VIDEO_BY_FILE_ID_MUTATION = /* #__PURE__ */registerMutation({
  fieldName: HARD_DELETE_VIDEO_BY_FILE_ID_MUTATION_FIELD_NAME,
  args: ['sourceFileId'],
  fetcher(request, ctx) {
    var _ctx$customClient10;
    return ((_ctx$customClient10 = ctx.customClient) !== null && _ctx$customClient10 !== void 0 ? _ctx$customClient10 : chirpClient).call(References.hardDeleteVideoByFileIdRpc, {
      timeout: ctx.timeout,
      request
    });
  }
});

/**
 * Docs: https://private.hubteam.com/shoebill/service/com.hubspot.video.rpc.HubSpotVideoRpc#updateVideoByFileId
 */
export const UPDATE_VIDEO_BY_FILE_ID_MUTATION_FIELD_NAME = 'com_hubspot_video_rpc_HubSpotVideoRpc_updateVideoByFileId';
export const UPDATE_VIDEO_BY_FILE_ID_MUTATION = /* #__PURE__ */registerMutation({
  fieldName: UPDATE_VIDEO_BY_FILE_ID_MUTATION_FIELD_NAME,
  args: ['fileId', 'fileName', 'seoTitle', 'description', 'tags', 'thumbnailSourceFileId', 'thumbnailSourceMilliseconds', 'isEmbeddable', 'chapters', 'videoAttributes', 'posterUrl', 'changeSource', 'clearChapters'],
  fetcher(request, ctx) {
    var _ctx$customClient11;
    return ((_ctx$customClient11 = ctx.customClient) !== null && _ctx$customClient11 !== void 0 ? _ctx$customClient11 : chirpClient).call(References.updateVideoByFileIdRpc, {
      timeout: ctx.timeout,
      request
    });
  }
});

/**
 * Docs: https://private.hubteam.com/shoebill/service/com.hubspot.video.rpc.HubSpotVideoRpc#setThumbnail
 */
export const SET_THUMBNAIL_MUTATION_FIELD_NAME = 'com_hubspot_video_rpc_HubSpotVideoRpc_setThumbnail';
export const SET_THUMBNAIL_MUTATION = /* #__PURE__ */registerMutation({
  fieldName: SET_THUMBNAIL_MUTATION_FIELD_NAME,
  args: ['fileId', 'thumbnailFileId', 'thumbnailTimestampMillis'],
  fetcher(request, ctx) {
    var _ctx$customClient12;
    return ((_ctx$customClient12 = ctx.customClient) !== null && _ctx$customClient12 !== void 0 ? _ctx$customClient12 : chirpClient).call(References.setThumbnailRpc, {
      timeout: ctx.timeout,
      request
    });
  }
});

/**
 * Docs: https://private.hubteam.com/shoebill/service/com.hubspot.video.rpc.HubSpotVideoRpc#updateVideoEmbeddability
 */
export const UPDATE_VIDEO_EMBEDDABILITY_MUTATION_FIELD_NAME = 'com_hubspot_video_rpc_HubSpotVideoRpc_updateVideoEmbeddability';
export const UPDATE_VIDEO_EMBEDDABILITY_MUTATION = /* #__PURE__ */registerMutation({
  fieldName: UPDATE_VIDEO_EMBEDDABILITY_MUTATION_FIELD_NAME,
  args: ['isEmbeddable', 'sourceFileId'],
  fetcher(request, ctx) {
    var _ctx$customClient13;
    return ((_ctx$customClient13 = ctx.customClient) !== null && _ctx$customClient13 !== void 0 ? _ctx$customClient13 : chirpClient).call(References.updateVideoEmbeddabilityRpc, {
      timeout: ctx.timeout,
      request
    });
  }
});

/**
 * Docs: https://private.hubteam.com/shoebill/service/com.hubspot.video.rpc.HubSpotVideoRpc#updateVideoVisibility
 */
export const UPDATE_VIDEO_VISIBILITY_MUTATION_FIELD_NAME = 'com_hubspot_video_rpc_HubSpotVideoRpc_updateVideoVisibility';
export const UPDATE_VIDEO_VISIBILITY_MUTATION = /* #__PURE__ */registerMutation({
  fieldName: UPDATE_VIDEO_VISIBILITY_MUTATION_FIELD_NAME,
  args: ['visibility', 'sourceFileId'],
  fetcher(request, ctx) {
    var _ctx$customClient14;
    return ((_ctx$customClient14 = ctx.customClient) !== null && _ctx$customClient14 !== void 0 ? _ctx$customClient14 : chirpClient).call(References.updateVideoVisibilityRpc, {
      timeout: ctx.timeout,
      request
    });
  }
});

/**
 * Docs: https://private.hubteam.com/shoebill/service/com.hubspot.video.rpc.HubSpotVideoRpc#getVideoLimitInfo
 */
export const GET_VIDEO_LIMIT_INFO_QUERY_FIELD_NAME = 'com_hubspot_video_rpc_HubSpotVideoRpc_getVideoLimitInfo';
export const GET_VIDEO_LIMIT_INFO_QUERY = /* #__PURE__ */registerQuery({
  fieldName: GET_VIDEO_LIMIT_INFO_QUERY_FIELD_NAME,
  args: [],
  fetcher(_, ctx) {
    var _ctx$customClient15;
    return ((_ctx$customClient15 = ctx.customClient) !== null && _ctx$customClient15 !== void 0 ? _ctx$customClient15 : chirpClient).call(References.getVideoLimitInfoRpc, {
      timeout: ctx.timeout
    });
  }
});

/**
 * Docs: https://private.hubteam.com/shoebill/service/com.hubspot.video.rpc.HubSpotVideoRpc#getVideoLimitInfoForDisplay
 */
export const GET_VIDEO_LIMIT_INFO_FOR_DISPLAY_QUERY_FIELD_NAME = 'com_hubspot_video_rpc_HubSpotVideoRpc_getVideoLimitInfoForDisplay';
export const GET_VIDEO_LIMIT_INFO_FOR_DISPLAY_QUERY = /* #__PURE__ */registerQuery({
  fieldName: GET_VIDEO_LIMIT_INFO_FOR_DISPLAY_QUERY_FIELD_NAME,
  args: [],
  fetcher(_, ctx) {
    var _ctx$customClient16;
    return ((_ctx$customClient16 = ctx.customClient) !== null && _ctx$customClient16 !== void 0 ? _ctx$customClient16 : chirpClient).call(References.getVideoLimitInfoForDisplayRpc, {
      timeout: ctx.timeout
    });
  }
});

/**
 * Docs: https://private.hubteam.com/shoebill/service/com.hubspot.video.rpc.HubSpotVideoRpc#getOrCreateShareKey
 */
export const GET_OR_CREATE_SHARE_KEY_MUTATION_FIELD_NAME = 'com_hubspot_video_rpc_HubSpotVideoRpc_getOrCreateShareKey';
export const GET_OR_CREATE_SHARE_KEY_MUTATION = /* #__PURE__ */registerMutation({
  fieldName: GET_OR_CREATE_SHARE_KEY_MUTATION_FIELD_NAME,
  args: ['fileId'],
  fetcher(request, ctx) {
    var _ctx$customClient17;
    return ((_ctx$customClient17 = ctx.customClient) !== null && _ctx$customClient17 !== void 0 ? _ctx$customClient17 : chirpClient).call(References.getOrCreateShareKeyRpc, {
      timeout: ctx.timeout,
      request
    });
  }
});

/**
 * Docs: https://private.hubteam.com/shoebill/service/com.hubspot.video.rpc.HubSpotVideoRpc#deleteShareKey
 */
export const DELETE_SHARE_KEY_MUTATION_FIELD_NAME = 'com_hubspot_video_rpc_HubSpotVideoRpc_deleteShareKey';
export const DELETE_SHARE_KEY_MUTATION = /* #__PURE__ */registerMutation({
  fieldName: DELETE_SHARE_KEY_MUTATION_FIELD_NAME,
  args: ['fileId'],
  fetcher(request, ctx) {
    var _ctx$customClient18;
    return ((_ctx$customClient18 = ctx.customClient) !== null && _ctx$customClient18 !== void 0 ? _ctx$customClient18 : chirpClient).call(References.deleteShareKeyRpc, {
      timeout: ctx.timeout,
      request
    });
  }
});

/**
 * Docs: https://private.hubteam.com/shoebill/service/com.hubspot.video.rpc.HubSpotVideoRpc#resolveShareKey
 */
export const RESOLVE_SHARE_KEY_QUERY_FIELD_NAME = 'com_hubspot_video_rpc_HubSpotVideoRpc_resolveShareKey';
export const RESOLVE_SHARE_KEY_QUERY = /* #__PURE__ */registerQuery({
  fieldName: RESOLVE_SHARE_KEY_QUERY_FIELD_NAME,
  args: ['shareKey'],
  fetcher(request, ctx) {
    var _ctx$customClient19;
    return ((_ctx$customClient19 = ctx.customClient) !== null && _ctx$customClient19 !== void 0 ? _ctx$customClient19 : chirpClient).call(References.resolveShareKeyRpc, {
      timeout: ctx.timeout,
      request
    });
  }
});

/**
 * Docs: https://private.hubteam.com/shoebill/service/com.hubspot.video.rpc.HubSpotVideoRpc#getSignedTranscripts
 */
export const GET_SIGNED_TRANSCRIPTS_QUERY_FIELD_NAME = 'com_hubspot_video_rpc_HubSpotVideoRpc_getSignedTranscripts';
export const GET_SIGNED_TRANSCRIPTS_QUERY = /* #__PURE__ */registerQuery({
  fieldName: GET_SIGNED_TRANSCRIPTS_QUERY_FIELD_NAME,
  args: ['videoId'],
  fetcher(request, ctx) {
    var _ctx$customClient20;
    return ((_ctx$customClient20 = ctx.customClient) !== null && _ctx$customClient20 !== void 0 ? _ctx$customClient20 : chirpClient).call(References.getSignedTranscriptsRpc, {
      timeout: ctx.timeout,
      request
    });
  }
});

/**
 * Docs: https://private.hubteam.com/shoebill/service/com.hubspot.video.rpc.HubSpotVideoRpc#getPreviewPlayer
 */
export const GET_PREVIEW_PLAYER_QUERY_FIELD_NAME = 'com_hubspot_video_rpc_HubSpotVideoRpc_getPreviewPlayer';
export const GET_PREVIEW_PLAYER_QUERY = /* #__PURE__ */registerQuery({
  fieldName: GET_PREVIEW_PLAYER_QUERY_FIELD_NAME,
  args: ['videoId', 'parentDomain'],
  fetcher(request, ctx) {
    var _ctx$customClient21;
    return ((_ctx$customClient21 = ctx.customClient) !== null && _ctx$customClient21 !== void 0 ? _ctx$customClient21 : chirpClient).call(References.getPreviewPlayerRpc, {
      timeout: ctx.timeout,
      request
    });
  }
});